export interface CooIntegrationRequestBody {
    body: {
        ProcessName: 'DC Get COO List WF';
        IncomingHierarchy: {
            MessageId: string;
            IntObjectName: 'DCCOOListIO';
            MessageType: 'Integration Object';
            IntObjectFormat: 'Siebel Hierarchical';
            ListOfDCCOOListIO: {
                'DC COO SR Thin BC': {
                    'Account Number': number | string;
                    'DC COO Number': string | null;
                    'SR Number': string | null;
                };
            };
        };
        Language: 'ENU';
        PageSize: '2';
        StartRowNum: 0;
        NewQuery: 'true';
        NoDays: '100';
    };
}

// This method is used to create coo integration request using account number and coo number
export function createCooIntegrationRequest(
    accountNumber: number | string, cooNumber: string | null
): CooIntegrationRequestBody {
    return {
        body: {
            ProcessName: 'DC Get COO List WF',
            IncomingHierarchy: {
                MessageId: generateUniqueId(), // Replace with actual utility
                IntObjectName: 'DCCOOListIO',
                MessageType: 'Integration Object',
                IntObjectFormat: 'Siebel Hierarchical',
                ListOfDCCOOListIO: {
                    'DC COO SR Thin BC': {
                        'Account Number': accountNumber,
                        'DC COO Number': cooNumber,
                        'SR Number': ''
                    },
                },
            },
            Language: 'ENU',
            PageSize: '2',
            StartRowNum: 0,
            NewQuery: 'true',
            NoDays: '100',
        },
    };
}

// Stub for unique ID generator
// This method is used to generate unique id
function generateUniqueId(): string {
    const now = new Date();
    // This method is used to pad using n
    const pad = (n: number) => n.toString().padStart(2, '0');

    const datePart = `${now.getFullYear()}${pad(now.getMonth() + 1)}${pad(now.getDate())}`;
    const timePart = `${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}${now.getMilliseconds().toString().padStart(3, '0')}`;
    return `${datePart}${timePart}`;
}
